import { Friend, FriendModel } from '@/core/interfaces';

export const UserFriendsMapper = ({
	friendUserId,
	username,
	name,
	generatedCoins,
	levelInfo,
	rewardsByReferral,
}: FriendModel): Friend => {
	const userFriendData: Friend = {
		friendId: friendUserId,
		username: username,
		name: name,
		pointsGenerated: generatedCoins,
		points: rewardsByReferral,
		level: {
			level: levelInfo.level,
			name: levelInfo.name,
			image: levelInfo.imageUrl,
		},
	};

	return userFriendData;
};
